import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20Korean%20webtoon%20inspired%20illustration%20with%20soft%20pastel%20gradient%20background%20featuring%20floating%20comic%20panel%20outlines%20and%20speech%20bubbles%20subtle%20manga%20style%20decorative%20elements%20warm%20coral%20and%20cream%20tones%20dreamy%20atmospheric%20digital%20art&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫网 - 在线免费阅读韩国漫画"
          className="w-full h-full object-cover object-top"
          title="在线韩漫_免费阅读韩国漫画_韩漫大全_韩漫网"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-4 leading-tight">
          在线韩漫，免费阅读韩国漫画大全
        </h1>
        <p className="text-sm md:text-lg text-background-50/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          资源齐全，更新及时，操作简单，多设备兼容 —— 您休闲时探索漫画世界的完美伙伴
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            开始阅读
          </Link>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-heart-line"></i>
            恋爱漫画
          </Link>
        </div>
      </div>
    </section>
  );
}